// `closingStatus` choices. The backend model carries no option list for this
// field (a plain string on UnderwritingBaseModel), so the drilldown's list is
// the source of truth — copied VERBATIM from the Loan Info / Details /
// Terms Sheet dropdowns, which all carried this same inline list.
export const selectOptionsClosingStatus = [
  "An issue with the file",
  "Clearing Post Closing Conditions",
  "Documents drafted",
  "Engage Counsel",
  "Executed Loan Docs Received and Under Review",
  "Expecting incoming wire",
  "Funded",
  "Loan docs need to be drafted",
  "Loan docs out for execution",
  "Opened with Counsel",
  "P/C Collateral Cleared",
  "P/C Pending Scans",
  "P/C Scans Received and Under Review",
  "Ready for QC Review",
  "Ready to request wire",
  "Requested wire",
  "Settlement Statement Under Review",
  "SS out for signature",
  "Waiting for incoming wire",
];
